/**
 * @module
 * @format
 */

/**
 * @import {FskKey} from 'acng/model';
 */

import {startUpLanguage} from 'acng/core/service/env.js';
import {user} from '../user/user.js';

/**
 * @typedef {{[key in FskKey]?: {[key: string]: string | undefined}} | null} FskTrans
 */

/**
 * @param {FskTrans | null | undefined} input
 * @returns {string | null} -
 */
export function fskTrans(input) {
  const {fsk, lang} = user;

  let res = input?.[fsk]?.[lang],
    hitF = false,
    hitL = false,
    fallback;

  if (!res && input) {
    for (const [cFsk, cLngs] of Object.entries(input)) {
      const cf = parseInt(cFsk);
      if (hitF && hitL) break;
      if (cf <= fsk) {
        for (const [cLng, val] of Object.entries(cLngs)) {
          if (hitL) break;
          if (val && cLng === lang) {
            if (cf == fsk) {
              hitF = true;
            }
            hitL = true;
            res = val;
          } else if (val && cLng === startUpLanguage) {
            res = val;
          } else if (val) {
            fallback = val;
          }
        }
      }
    }
  }

  return res ?? fallback ?? null;
}
